import { MediaData } from "@demo/types/base";

/** Return media in the editor's ID order, followed by media from older nodes. */
export function orderMediaByIds<T extends Pick<MediaData, "key">>(
  media: T[],
  mediaIds?: readonly string[] | null,
): T[] {
  if (!mediaIds?.length) return media;

  const mediaById = new Map(media.map((item) => [item.key, item]));
  const ordered = mediaIds.flatMap((id) => {
    const item = mediaById.get(id);
    if (!item) return [];
    mediaById.delete(id);
    return [item];
  });

  ordered.push(...mediaById.values());
  return ordered;
}

/** Return only the media named by an editor node, in that node's order. */
export function selectMediaByIds<T extends Pick<MediaData, "key">>(
  media: T[],
  mediaIds?: readonly string[] | null,
): T[] {
  if (mediaIds == null) return media;

  const mediaById = new Map(media.map((item) => [item.key, item]));
  return mediaIds.flatMap((id) => {
    const item = mediaById.get(id);
    if (!item) return [];
    mediaById.delete(id);
    return [item];
  });
}
